export const AppContextProvider = ({ children }: React.PropsWithChildren) => {
  return children;
};
